import { GAME_CONFIG } from '../config/gameConfig';
import type { GamePhase, GameState } from '../state/types';

function els() {
  return {
    overlay: document.getElementById('end-screen'),
    title: document.getElementById('end-screen-title'),
    subtitle: document.getElementById('end-screen-subtitle'),
    panel: document.getElementById('end-screen-panel'),
  };
}

export function hideEndScreen(): void {
  const { overlay } = els();
  if (overlay) overlay.classList.add('hidden');
}

export function showEndScreen(phase: Exclude<GamePhase, 'playing'>): void {
  const { overlay, title, subtitle, panel } = els();
  if (!overlay || !title || !subtitle || !panel) return;

  const winCash = GAME_CONFIG.economy.winCash;

  if (phase === 'won') {
    title.textContent = 'Győztél!';
    title.className = 'text-4xl md:text-5xl font-bold tracking-tight text-emerald-300';
    subtitle.textContent = `Elérted a $${winCash}-s gazdasági célt. A növényvédelem sikeres volt.`;
    panel.className =
      'max-w-md w-full mx-4 p-8 rounded-2xl border border-emerald-500/30 bg-slate-950/95 shadow-2xl text-center flex flex-col items-center gap-4';
  } else {
    title.textContent = 'Vereség';
    title.className = 'text-4xl md:text-5xl font-bold tracking-tight text-red-400';
    subtitle.textContent =
      'Minden parcella elpusztult. Nincs mit megmenteni — indítsd újra a szimulációt.';
    panel.className =
      'max-w-md w-full mx-4 p-8 rounded-2xl border border-red-500/30 bg-slate-950/95 shadow-2xl text-center flex flex-col items-center gap-4';
  }

  subtitle.className = 'text-sm text-slate-400 leading-relaxed';
  overlay.classList.remove('hidden');
}

export function syncEndScreen(state: GameState): void {
  if (state.phase === 'playing') {
    hideEndScreen();
  } else {
    showEndScreen(state.phase);
  }
}
